// extracted by mini-css-extract-plugin
export var lg = "_ke-7";
export var md = "_ke-6";
export var placeholderContainer = "_ke-1";
export var placeholderIcon = "_ke-2";
export var productImage = "_ke-0";
export var sm = "_ke-5";
export var xl = "_ke-8";
export var xs = "_ke-4";
export var xxs = "_ke-3";